import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Repository } from '@repositories/models';
import { PagedData } from '@core/models/datables';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RepositoryBaseService {
  rows: any;
  onKBChanged: BehaviorSubject<any>;

  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _http: HttpClient) {
    // Set the defaults
    // this.onKBChanged = new BehaviorSubject({});
  }

  getRepositories( page: number, quantity: number) {
    return this._http.get<PagedData<Repository>>(`${environment.repositoriesApiUrl}/api/repos/page/${page}/${quantity}`);
  }

  getRepoByCode(code: string) {
    return this._http.get<any>(`${environment.repositoriesApiUrl}/api/repos/${code}`);
  }

  getUploadUrl(fileName: string) {
    return this._http.get<any>(`${environment.repositoriesApiUrl}/api/repos/upload/${fileName}`);
  }

  uploadFile(url: string, contentType, file){
    let headers = new HttpHeaders().set('Content-Type', contentType).set('x-ms-blob-type','BlockBlob');
    return this._http.put<any>(url,file,{ headers: headers});
  }

  addRepository(repo: Repository){
    return this._http.post<Repository>(`${environment.repositoriesApiUrl}/api/repos`, repo).pipe(
      map((response: any) => response.repo as Repository),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editRepository(repo: Repository){
    return this._http.put<Repository>(`${environment.repositoriesApiUrl}/api/repos/${repo.id}`, repo).pipe(
      map((response: any) => response.repo as Repository),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  deleteRepository(repoId: string){
    return this._http.put<any>(`${environment.repositoriesApiUrl}/api/repos/delete/${repoId}`,null);
  }

  getAllLite(){
    return this._http.get<any>(`${environment.repositoriesApiUrl}/api/repos/lite/all`);
  }

}
